import { authorizedEdgeFetch } from 'app/axios/edge'

export const fetchRootDomains = () =>
  authorizedEdgeFetch.get(`/rms/domains/roots`)
